import { Component, computed, effect, Input, OnInit, inject, ChangeDetectionStrategy } from '@angular/core';
import { Location } from '@angular/common';
import { ICustomWindow, WindowRefService } from '@sirius/common';
import { MatchmakingData, Steps } from 'matchmaking/models';
import { StepIndustryComponent } from '../step-industry/step-industry.component';

import {
    MatchmakingApiService,
    MatchmakingContentService,
    MatchmakingDataService,
} from 'matchmaking/services';
import { FormStepHeaderWrapperComponent } from '../form-step-header-wrapper/form-step-header-wrapper.component';
import { ResultPageComponent } from '../result-page/result-page.component';
import { StepApplicationComponent } from '../step-application/step-application.component';
import { StepApplicationSpecificComponent } from '../step-application-specific/step-application-specific.component';
import { StepProjectComponent } from '../step-project/step-project.component';
import { StepPreviewComponent } from '../step-preview/step-preview.component';

@Component({
    selector: 'matchmaking-root',
    imports: [
    StepIndustryComponent,
    StepApplicationComponent,
    StepProjectComponent,
    StepPreviewComponent,
    FormStepHeaderWrapperComponent,
    ResultPageComponent,
    StepApplicationSpecificComponent
],
    templateUrl: './matchmaking.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrl: './matchmaking.component.scss'
})
export class MatchmakingComponent implements OnInit {
    private dataService = inject(MatchmakingDataService);
    private contentService = inject(MatchmakingContentService);
    private apiService = inject(MatchmakingApiService);
    private _location = inject(Location);
    private _windowRef = inject(WindowRefService);

    @Input()
    config!: MatchmakingData;

    isCompleted = computed(
        () => this.dataService.config()?.isCompleted && this.dataService.formHasSubmitted(),
    );
    currentStepContent = computed(() => this.contentService.currentStepContent());
    currentStepName = computed(() => this.contentService.currentStepName());
    protected readonly MATCHMAKING_STEPS = Steps;

    formContent = computed(() => {
        return {
            config: this.dataService.config(),
            content: this.contentService.currentStepContent,
        };
    });

    private get Window(): ICustomWindow | undefined {
        return this._windowRef.NativeWindow;
    }


    constructor() {
        const _location = this._location;

        effect(() => {
            // Adds a param that indicates when the guide has been completed, used for tracking purposes
            const currentPath = _location.path();
            const param = this.isCompleted() ? 'resultPage=1' : '';
            this._location.replaceState(currentPath, param);
        });

        effect(() => {
            if (!this.Window) {
                return;
            }

            const _ = this.currentStepName();

            // Whenever step changes, we want to scroll to the top (will be triggered on both prev/next)
            window.scrollTo({
                top: 0,
                behavior: 'smooth',
            });
        });
    }

    ngOnInit() {
        this.apiService.initializeData(this.config);
    }
}
